import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link2, TrendingUp, Search, Target, FileText, Sparkles, Users } from 'lucide-react';
const skills = [{
  title: 'Marketing de Afiliados',
  description: 'Estrategias avanzadas de promoción y conversión de productos digitales.',
  icon: Link2
}, {
  title: 'Tráfico Orgánico',
  description: 'Atracción de audiencias altamente cualificadas sin inversión publicitaria.',
  icon: TrendingUp
}, {
  title: 'SEO',
  description: 'Posicionamiento en buscadores para capturar demanda con alta intención.',
  icon: Search
}, {
  title: 'Marketing CPA',
  description: 'Optimización de campañas basadas en costo por adquisición.',
  icon: Target
}, {
  title: 'Estrategia de Contenido',
  description: 'Creación de contenido persuasivo, storytelling y psicología digital.',
  icon: FileText
}, {
  title: 'Branding Digital',
  description: 'Construcción de marcas personales sólidas y confiables en internet.',
  icon: Sparkles
}, {
  title: 'Construcción de Audiencia',
  description: 'Desarrollo y monetización de comunidades leales a largo plazo.',
  icon: Users
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function Skills() {
  return <section id="expertise" className="py-24 md:py-32 relative bg-[#0a0a0b]" data-id="element-111">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/[0.01] to-transparent pointer-events-none" data-id="element-112" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 md:mb-24" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-bold text-zinc-100 mb-6" data-id="element-115">
            Áreas de Expertise
          </h2>
          <p className="text-zinc-400 max-w-2xl text-lg" data-id="element-116">
            Habilidades desarrolladas a lo largo de más de una década en las
            trincheras del marketing digital, enfocadas en resultados reales.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-117">
          {skills.map((skill, index) => {
          const Icon = skill.icon;
          return <motion.div key={index} variants={itemVariants} className="group relative bg-white/[0.02] border border-white/5 p-8 rounded-2xl backdrop-blur-sm hover:bg-white/[0.04] hover:border-amber-400/30 transition-all duration-300" data-id="element-118">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-400/0 to-amber-400/0 group-hover:from-amber-400/5 group-hover:to-transparent rounded-2xl transition-colors duration-500 pointer-events-none" data-id="element-119" />

                <div className="w-12 h-12 rounded-xl bg-[#0a0a0b] border border-white/10 group-hover:border-amber-400/50 flex items-center justify-center mb-6 transition-colors duration-300 shadow-sm group-hover:shadow-[0_0_15px_rgba(251,191,36,0.15)]" data-id="element-120">
                  <Icon className="w-5 h-5 text-zinc-300 group-hover:text-amber-400 transition-colors duration-300" data-id="element-121" />
                </div>

                <h3 className="text-xl font-semibold text-zinc-100 mb-3" data-id="element-122">
                  {skill.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-123">
                  {skill.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}